import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { COUNTRY_NONE } from "@/lib/sign-up-countries";
import { memo } from "react";

interface CountryOption {
  code: string;
  label: string;
}

type Props = {
  required: boolean;
  valueCode: string;
  onPick: (isoCodeOrEmpty: string) => void;
  ariaLabel: string;
  options: CountryOption[];
  optionsLoading?: boolean;
  disabled?: boolean;
};

export const SignUpCountrySelect = memo(function SignUpCountrySelect({
  required,
  valueCode,
  onPick,
  ariaLabel,
  options,
  optionsLoading,
  disabled,
}: Props) {
  const selectValue = required ? valueCode || undefined : valueCode ? valueCode : COUNTRY_NONE;

  return (
    <Select
      value={selectValue}
      onValueChange={v => onPick(v === COUNTRY_NONE ? "" : v)}
      disabled={disabled || optionsLoading}
    >
      <SelectTrigger className="w-full" aria-label={ariaLabel}>
        <SelectValue
          placeholder={optionsLoading ? "Loading countries…" : required ? "Select country" : "Country (optional)"}
        />
      </SelectTrigger>
      <SelectContent className="max-h-[min(18rem,70vh)] overflow-y-auto">
        {!required && (
          <SelectItem value={COUNTRY_NONE} className="text-muted-foreground">
            —
          </SelectItem>
        )}
        {options.map(({ code, label: countryLabel }) => (
          <SelectItem key={code} value={code}>
            {countryLabel}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});
